import { Outlet } from 'react-router-dom';
import { MarketProvider } from '../context/MarketContext';

const MarketWrapper = () => {
  return (
    <MarketProvider>
      <Outlet />
    </MarketProvider> 
  );
};

export default MarketWrapper;
